"use client"; // ✅ Mark as Client Component

import { useParams } from "next/navigation"; // ✅ Can now be used
import { useTranslation } from "@/app/i18n/i18n-client";
import Header from "@/components/headers/Header";
import Footer from "@/components/footers/Footer";
import Image from "next/image";
import Link from "next/link";

export const metadata = {
  title: "Not Found || KauFast - Agencia SEO",
};

export default function NotFoundPage() {
  const params = useParams(); // ✅ Now allowed
  const locale = params?.locale || "en-GB"; // ✅ Fallback to "es-ES"
  const { t } = useTranslation(locale, "not-found"); // ✅ Correct usage

  return (
    <>
      <Header locale={locale} />
      <div className="error-wrapper text-center">
        <div className="container">
          <Image
            width={856}
            height={246}
            className="mb-50"
            src="/assets/img/normal/404.png"
            alt={t("imageAlt")}
          />
          <h2>{t("title")}</h2>
          <p className="sec-text mb-30">{t("description")}</p>
          <Link href="/" className="link-btn">
            <span className="link-effect">
              <span className="effect-1">{t("buttonText")}</span>
              <span className="effect-1">{t("buttonText")}</span>
            </span>
            <Image
              width={13}
              height={13}
              style={{ width: "13px", height: "13px" }}
              loading="lazy"
              src="/assets/img/icon/arrow-left-top.svg"
              alt="Arrow icon"
            />
          </Link>
        </div>
      </div>
      <Footer locale={locale} />
    </>
  );
}
